import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/meta-pixel";

// Fires a Meta Pixel PageView on the initial load and on every client-side
// navigation. The Pixel itself only initializes where advertising permission
// allows it, so this component is safe to mount globally.
export const MetaPixelRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    void trackPageView();
  }, [location.pathname]);

  return null;
};
